import { ReactElement } from 'react';
import { HotelNote } from '../../../store';
import { MutableCustom } from '../../../utils/inputUtils';
import { NoteCustomFields, FixedNoteField, AddFieldButton } from '../EditNote/EditNote';
import { NEW_HOTEL_SRC } from '../../../resourceUrls';
import { Box, Typography } from '@mui/material';

interface Props {
  hotelNote: HotelNote;
  changeFunc: (field: string, custom?: boolean, label?: boolean) => ((newValue: string) => void);
  handleCustomChange: (index: number, label?: boolean) => ((newValue: string) => void);
  headerChange: (field: string, value: string) => void;
  mutableCustom: MutableCustom;
  addCustomField: () => void;
  onDelete: (index: number) => (() => void);
}

export const EditHotelNote = ({ hotelNote, changeFunc, headerChange, mutableCustom,
  addCustomField, onDelete, handleCustomChange}: Props): ReactElement => {

  const renderNameOrInput = (): ReactElement => {
    if (hotelNote.hotel_data.id === -1) {
      return (
        <>
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              marginTop: 1,
              marginBottom: 1
            }}>
            <Box component={'img'} src={hotelNote.hotel_data.icon_url || NEW_HOTEL_SRC} sx={{
              width: 24
            }} />
          </Box>
          <FixedNoteField fieldLabelKey="hotel_name" placeholder="Enter a name" 
            value={hotelNote.hotel_data.name} changeFunc={(value): void => headerChange('name', value || '')}/>
        </>
      );
    } else {
      return (
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            marginTop: 1,
            marginBottom: 1
          }}>
          <Box component={'img'} src={hotelNote.hotel_data.icon_url || NEW_HOTEL_SRC} sx={{
            width: 24
          }} />
          <Typography sx={{
            fontWeight: 700
          }}>{hotelNote.hotel_data.name}</Typography>
        </Box>
      );
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1
      }}>
      {renderNameOrInput()}
      { !hotelNote.hotel_data.is_default &&
      <>
        <FixedNoteField fieldLabelKey="hotel_phone_number" placeholder="Enter a number" 
          value={hotelNote.hotel_data.phone_number}  
          changeFunc={(value): void => headerChange('phone_number', value || '')}/>

        <FixedNoteField fieldLabelKey="hotel_website_url" placeholder="Enter website" 
          value={hotelNote.hotel_data.website_url}
          changeFunc={(value): void => headerChange('website_url', value || '')}/>
      </>}
      <FixedNoteField fieldLabelKey="loyalty_number" placeholder="Enter number"
        value={hotelNote.loyalty_number} changeFunc={changeFunc('loyalty_number')}/>
      <FixedNoteField fieldLabelKey="username" placeholder="Enter username" 
        value={hotelNote.username} changeFunc={changeFunc('username')}/>
      <FixedNoteField fieldLabelKey="notes" placeholder="Enter note" 
        value={hotelNote.notes} changeFunc={changeFunc('notes')}/>
      <NoteCustomFields mutableCustom={mutableCustom} changeFunc={handleCustomChange} onDelete={onDelete} />
      <AddFieldButton onClick={addCustomField}/>
    </Box>
  );
};

export default EditHotelNote;